import React from 'react'
import './Footer.css'
import '../../styling/glyphicons/glyphicons.css'

function Footer() {
  return (
    <>
      <div id='footer' className='mt-auto text-center text-white'>
        <ul>
          <li className='foorterDate'>
            <span className='glyphicons glyphicons-copyright-mark'>
              {new Date().getFullYear()}
            </span>
          </li>
          <li className='footerText'>
            <a
              href='http://www.intrepidcs.com'
              target='_new'
              className='text-white'
            >
              Intrepid Control Systems, Inc
            </a>{' '}
            |{' '}
          </li>
          <li className='footerText'>
            <a
              href='http://www.wirelessneovi.com'
              target='_new'
              className='text-white'
            >
              Wireless neoVI
            </a>
          </li>
        </ul>
      </div>
    </>
  )
}

export default Footer
